// Wait for page load to ensure proper position calculations
window.addEventListener('load', () => {
	// Exclude elements inside .stats since that section handles its own visibility
	const fadeElements = document.querySelectorAll('[data-fade]:not(.stats [data-fade])')

	if (fadeElements.length > 0) {
		gsap.registerPlugin(ScrollTrigger)

		fadeElements.forEach((el) => {
			const fadeType = el.dataset.fade

			// Use opacity instead of autoAlpha - visibility:hidden removes elements from
			// tab order and breaks keyboard nav. Opacity keeps focusable descendants reachable.
			const initialState = { opacity: 0 }

			switch (fadeType) {
				case 'fade-left':
					initialState.x = -50
					break
				case 'fade-right':
					initialState.x = 50
					break
				case 'fade-up':
					initialState.y = 50
					break
				// 'fade-in' just uses opacity, no transform needed
			}

			el.setAttribute('aria-hidden', 'true')
			gsap.set(el, initialState)

			// Animate to final state
			const animateState = {
				opacity: 1,
				duration: 0.5,
				ease: 'ease-in-out'
			}

			if (initialState.x !== undefined) animateState.x = 0
			if (initialState.y !== undefined) animateState.y = 0

			gsap.to(el, {
				...animateState,
				onComplete: () => el.removeAttribute('aria-hidden'),
				scrollTrigger: {
					trigger: el,
					start: 'top 85%',
					toggleActions: 'play none none reset',
					onLeaveBack: () => el.setAttribute('aria-hidden', 'true')
				}
			})
		})
	}
})
